module.exports = [{
      plugin: require('/zeit/c8aef64/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"","head":true},
    },{
      plugin: require('/zeit/c8aef64/gatsbyjs/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
